import React from "react";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "../style/imagemodal.css"; // Ensure you have this file or add appropriate styling

const ImageModal = ({ open, handleClose, imageUrl }) => {
  return (
    <Modal open={open} onClose={handleClose} className="modal">
      <div className="modal-content">
        <IconButton className="close-button" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <img src={imageUrl} alt="modal-img" className="modal-img" />
      </div>
    </Modal>
  );
};

export default ImageModal;
